<template>
    <div>
        <div class="contentMenu">
            <div class="menuItem" @click="changeSection('act')" :class="{'active': section === 'act'}">Akta informācija</div>
            <div class="menuItem" @click="changeSection('items')" :class="{'active': section === 'items'}">Priekšmeti</div>
        </div>
        <div class="content">
            <div class="loader" v-if="loading">
                <img src="/images/loading.svg" alt="Loading">
            </div>
            <div class="main">
                <div class="section" v-if="section == 'act'">
                    <div class="sectionTitle">Akta informācija</div>
                    <div class="sectionContent">
                        <div class="subsection">
                            <div class="title">
                                Akta pamatinformācija
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="act_number">Akta numurs</label>
                                    <input type="text" name="act_number" id="act_number" v-model="act_number" class="form-control" autocomplete="off">
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="act_date">Datums</label>
                                    <v-date-picker
                                        :popover="{ visibility: 'click' }"
                                        mode="single"
                                        v-model="act_date"
                                        :type="'date'"
                                        :locale="'LV'"
                                        color="teal"
                                        :masks="{
                                            input: ['DD.MM.YYYY']
                                        }"
                                    />
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="act_due_date">Termiņš</label>
                                    <v-date-picker
                                        :popover="{ visibility: 'click' }"
                                        mode="single"
                                        v-model="act_due_date"
                                        :type="'date'"
                                        :locale="'LV'"
                                        color="teal"
                                        :masks="{
                                            input: ['DD.MM.YYYY']
                                        }"
                                    />
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="annex_to_the_act">Pielikumi</label>
                                    <textarea type="text" id="annex_to_the_act" v-model="annex_to_the_act" class="form-control">{{annex_to_the_act}}</textarea>
                                    <small>Brīvā tekstā</small>
                                </div>
                            </div>
                        </div>
                        <div class="subsection">
                            <div class="title">
                                Muzeja puses dati
                            </div>
                            <div class="actions"><button class="btn btn-sm btn-primary" @click="populateActDataWithCurrentUser()">Aizpildīt ar saviem datiem</button></div>
                        </div>
                        <div class="row">
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="act_receiver_firstname">Vārds</label>
                                    <input type="text" id="act_receiver_firstname" v-model="act_receiver_firstname" class="form-control">
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="act_receiver_lastname">Uzvārds</label>
                                    <input type="text" id="act_receiver_lastname" v-model="act_receiver_lastname" class="form-control">
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="act_receiver_position">Amats</label>
                                    <input type="text" id="act_receiver_position" v-model="act_receiver_position" class="form-control">
                                </div>
                            </div>
                        </div>
                        <div class="subsection">
                            <div class="title">
                                Otras puses dati
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="act_giver_type">Personas veids</label>
                                    <select name="act_giver_type" id="act_giver_type" v-model="act_giver_type" class="form-control">
                                        <option value="legal_person">Juridiska persona</option>
                                        <option value="individual">Fiziska persona</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="act_giver_type">
                            <hr>
                            <div class="col-3" v-if="act_giver_type==='legal_person'">
                                <div class="form-group">
                                    <label for="act_giver_institution_name">Institūcijas nosaukums</label>
                                    <input type="text" id="act_giver_institution_name" v-model="act_giver_institution_name" class="form-control">
                                </div>
                            </div>
                            <div class="col-3" v-if="act_giver_type==='legal_person'">
                                <div class="form-group">
                                    <label for="act_giver_position">Amats</label>
                                    <input type="text" id="act_giver_position" v-model="act_giver_position" class="form-control">
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="act_giver_firstname">Vārds</label>
                                    <input type="text" id="act_giver_firstname" v-model="act_giver_firstname" class="form-control">
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="act_giver_lastname">Uzvārds</label>
                                    <input type="text" id="act_giver_lastname" v-model="act_giver_lastname" class="form-control">
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="act_giver_address">Adrese</label>
                                    <input type="text" id="act_giver_address" v-model="act_giver_address" class="form-control">
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                    <label for="act_giver_reg_nr">Reg.nr./Pers. kods</label>
                                    <input type="text" id="	act_giver_reg_nr" v-model="	act_giver_reg_nr" class="form-control">
                                </div>
                            </div>
                        </div>
                        <div class="subsection">
                            <div class="title">
                                Akta sagatavotāja informācija
                            </div>
                            <div class="actions"><button class="btn btn-sm btn-primary" @click="populateActAuthorWithCurrentUser()">Aizpildīt ar saviem datiem</button></div>
                        </div>
                        <div class="row">
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="act_author_firstname">Vārds</label>
                                    <input type="text" id="act_author_firstname" v-model="act_author_firstname" class="form-control">
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="act_author_lastname">Uzvārds</label>
                                    <input type="text" id="act_author_lastname" v-model="act_author_lastname" class="form-control">
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="act_author_position">Amats</label>
                                    <input type="text" id="act_author_position" v-model="act_author_position" class="form-control">
                                </div>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-12 text-right">
                                <button class="btn btn-primary" @click="save()">Saglabāt</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="section" v-if="section == 'items'">
                    <div class="sectionTitle">Priekšmeti</div>
                    <div class="sectionContent">
                        <div class="row">
                            <div class="col-12">
                                <div class="text-right mt-2 mb-2">
                                    <button data-toggle="modal" data-target="#newitemmodal" class="btn btn-primary">Pievienot jaunu</button>
                                </div>
                                <div class="modal" tabindex="-1"  id="newitemmodal" ref="vuemodal" key="newitemmodal">
                                    <div class="modal-dialog" role="document">
                                        <div class="modal-content">
                                            <div class="loader" v-if="loading">
                                                <img src="/images/loading.svg" alt="Loading">
                                            </div>
                                            <div class="modal-header bg-primary text-white">
                                                <h5 class="modal-title">Priekšmeta pievienošana</h5>
                                                <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <div class="modal-body">
                                                <div class="row">
                                                    <div class="col-12 subsection">
                                                        <div class="title">
                                                            Jaunā priekšmeta dati
                                                        </div>
                                                    </div>
                                                    <div class="col-12">
                                                        <div class="form-group">
                                                            <label for="new_item_number">Numurs</label>
                                                            <input type="text" id="new_item_number" v-model="new_item_number" :class="{'is-invalid':errors && ( 'item_number' in errors)}" class="form-control" autocomplete="off">
                                                            <small class="text-danger" v-if="errors && errors.item_number">{{errors.item_number[0]}}</small>
                                                        </div>
                                                    </div>
                                                    <div class="col-12">
                                                        <div class="form-group">
                                                            <label for="new_item_name">Nosaukums</label>
                                                            <input type="text" id="new_item_name" v-model="new_item_name" :class="{'is-invalid':errors && ( 'item_name' in errors)}" class="form-control" autocomplete="off">
                                                            <small class="text-danger" v-if="errors && errors.item_name">{{errors.item_name[0]}}</small>
                                                        </div>
                                                    </div>
                                                    <div class="col-12">
                                                            <div class="form-group">
                                                                <label for="item_name">Veids</label>
                                                                <select name="item_type" id="item_type" class="form-control" v-model="new_item_type" :class="{'is-invalid':errors && ( 'item_type' in errors)}">
                                                                    <option value="main">Pamatkrājums</option>
                                                                    <option value="pk">Palīgkrājums</option>
                                                                </select>
                                                                <small class="text-danger" v-if="errors && errors.item_type">{{errors.item_type[0]}}</small>
                                                            </div>
                                                    </div>
                                                    <div class="col-12 text-right">
                                                        <button class="btn btn-primary" @click="create()">Pievienot</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <table class="table">
                            <thead class="bg-primary text-white">
                                <tr>
                                    <th>Attēls</th>
                                    <th>Numurs</th>
                                    <th>Nosaukums</th>
                                    <th>Apraksts</th>
                                    <th>Vērtība</th>
                                    <th class="text-right">Darbības</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in items" :key="item.id">
                                    <td><img v-if="item.images.length > 0" :src="'/temp-item/'+item.id+'/image/'+item.images[0].file" alt=""></td>
                                    <td>{{item.item_number}}</td>
                                    <td>{{item.item_name}}</td>
                                    <td>{{item.item_description}}</td>
                                    <td>{{item.item_value}}</td>
                                    <td class="actions">
                                        <temp-item-component :item="item"></temp-item-component>
                                        <div class="delete" @click="deleteItem(item.id)"><span class="material-icons">close</span></div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div v-if="items.length === 0" class="alert alert-info text-center">Aktam nav pievienots neviens priekšmets.</div>

                    </div>
                </div>
            </div>
            <div class="sidebar">
                <div class="inner">
                    <div class="section">
                        <div class="sectionTitle">Darbības</div>
                        <div class="sectionContent text-center">
                            <button class="btn btn-primary" @click="save()">Saglabāt informāciju</button>
                            <hr>
                            <a :href="'/temp-acts/generate-act/'+id" class="btn btn-primary m-1" target="_blank" >Ģenerēt aktu</a><br>
                        </div>
                    </div>
                    <div class="section">
                        <div class="sectionTitle">Papildus lauki</div>
                        <div class="sectionContent">
                            <div class="form-group">
                                <label for="agreement_number">Līguma nr.</label>
                                <input type="text" id="agreement_number" v-model="agreement_number" class="form-control">
                            </div>
                            <div class="form-group">
                                <label for="agreement_date">Līguma datums</label>
                                <v-date-picker
                                    :popover="{ visibility: 'click' }"
                                    mode="single"
                                    v-model="agreement_date"
                                    :type="'date'"
                                    :locale="'LV'"
                                    color="teal"
                                    :masks="{
                                            input: ['DD.MM.YYYY']
                                        }"
                                />
                            </div>
                            <div class="form-group">
                                <label for="agreement_extend_date">Pagarinājuma datums</label>
                                <v-date-picker
                                    :popover="{ visibility: 'click' }"
                                    mode="single"
                                    v-model="agreement_extend_date"
                                    :type="'date'"
                                    :locale="'LV'"
                                    color="teal"
                                    :masks="{
                                            input: ['DD.MM.YYYY']
                                        }"
                                />
                            </div>
                            <div class="form-group">
                                <label for="purpose">Nolūks</label>
                                <input type="text" id="purpose" v-model="purpose" class="form-control">
                            </div>
                            <div class="form-group">
                                <label for="agreement_receive_date">Atdošanas datums</label>
                                <v-date-picker
                                    :popover="{ visibility: 'click' }"
                                    mode="single"
                                    v-model="agreement_receive_date"
                                    :type="'date'"
                                    :locale="'LV'"
                                    color="teal"
                                    :masks="{
                                            input: ['DD.MM.YYYY']
                                        }"
                                />
                            </div>
                            <div class="form-group">
                                <label for="notes">Piezīmes</label>
                                <textarea type="text" id="notes" v-model="notes" class="form-control">{{notes}}</textarea>
                                <small>Informācija tiek attēlota reģistrācijas grāmatās.</small>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TempItemComponent from "./TempItemComponent";
export default{
    components: {TempItemComponent},
    props:['current_user','act'],
    mounted()
    {
        this.id=this.$props.act.id;
        this.act_number=this.$props.act.act_number;
        this.act_date=moment(this.$props.act.act_date, moment.ISO_8601)._d;
        this.act_receiver_firstname=this.$props.act.act_receiver_firstname;
        this.act_receiver_lastname=this.$props.act.act_receiver_lastname;
        this.act_receiver_position=this.$props.act.act_receiver_position;
        this.act_giver_type=this.$props.act.act_giver_type;
        this.act_giver_institution_name=this.$props.act.act_giver_institution_name;
        this.act_giver_position=this.$props.act.act_giver_position;
        this.act_giver_firstname=this.$props.act.act_giver_firstname;
        this.act_giver_lastname=this.$props.act.act_giver_lastname;
        this.act_giver_address=this.$props.act.act_giver_address;
        this.act_giver_reg_nr=this.$props.act.act_giver_reg_nr;
        this.act_due_date=moment(this.$props.act.act_due_date, moment.ISO_8601)._d;
        this.act_author_position=this.$props.act.act_author_position;
        this.act_author_firstname=this.$props.act.act_author_firstname;
        this.act_author_lastname=this.$props.act.act_author_lastname;
        this.annex_to_the_act=this.$props.act.annex_to_the_act;

        this.agreement_number=this.$props.act.agreement_number;
        this.agreement_date=moment(this.$props.act.agreement_date, moment.ISO_8601)._d;
        this.agreement_receive_date=moment(this.$props.act.agreement_receive_date, moment.ISO_8601)._d;
        this.agreement_extend_date=moment(this.$props.act.agreement_extend_date, moment.ISO_8601)._d;
        this.purpose=this.$props.act.purpose;
        this.notes=this.$props.act.notes;

        this.items = this.$props.act.items;

        var that = this;
        EventBus.$on('new_item_added', (data) =>{
            that.items = data.act.items;
            setTimeout(function(){
                $('#edit-'+data.item.id).modal('show');
            },500);

        });

        EventBus.$on('items_updated', (items) =>{
            that.items = items;
        });
        EventBus.$on('item_deleted', (data) =>{
            that.items = data.act.items;
        });
    },
    data(){
        return{
            loading:false,
            section:'act',
            id:"",
            act_number:"",
            act_date:"",
            act_receiver_firstname:"",
            act_receiver_lastname:"",
            act_receiver_position:"",
            act_giver_type:"",
            act_giver_institution_name:"",
            act_giver_position:"",
            act_giver_firstname:"",
            act_giver_lastname:"",
            act_giver_address:"",
            act_giver_reg_nr:"",
            act_due_date:"",
            act_author_position:"",
            act_author_firstname:"",
            act_author_lastname:"",
            annex_to_the_act:"",
            agreement_number:"",
            agreement_date:"",
            agreement_receive_date:"",
            agreement_extend_date:"",
            purpose:"",
            notes:"",



            items:[],

            new_item_number:"",
            new_item_name:"",
            new_item_type:"",
            errors:[],


        }
    },
    methods:{
        deleteItem(item_id)
        {
            var that = this;
            that.$swal.fire({
                title: 'Vai tiešām vēlaties dzēst priekšmetu?',
                text: "Priekšmets tiks dzēsts.",
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#E53935',
                cancelButtonColor: '#888787',
                confirmButtonText: 'Dzēst',
                cancelButtonText: 'Atcelt'
            }).then((result) => {
                    if (result.value) {
                        axios.post('/temp-item/delete/'+item_id)
                            .then(response =>{
                                if(response.data.status == 'ok')
                                {
                                    that.$toast.open(response.data.message);
                                    EventBus.$emit('item_deleted', response.data);
                                }
                                if(response.data.status == 'error')
                                {
                                    that.errors = response.data.errors;
                                    that.$toast.error(response.data.message);
                                }
                        })
                    }});
        },

        create()
        {
            var that = this;
            axios.post('/temp-items/create',{
                temp_act_id:that.id,
                item_number: that.new_item_number,
                item_name: that.new_item_name,
                item_type: that.new_item_type,
            }).then(response =>{
                if(response.data.status == 'ok')
                {
                    $(that.$refs.vuemodal).modal('hide');
                    that.$toast.open(response.data.message);
                    that.errors = [];
                    that.new_item_number="";
                    that.new_item_name="";
                    that.new_item_type="";
                    EventBus.$emit('new_item_added', response.data);
                }
                if(response.data.status == 'error')
                {
                    that.errors = response.data.errors;
                    that.$toast.error(response.data.message);
                }
            });

        },
        changeSection(section)
        {
            this.section = section;
        },
        save()
        {
            var that = this;
            axios.post('/temp-acts/update/'+that.$props.act.id,{
                act_number: that.act_number,
                act_date: that.act_date,
                act_receiver_firstname: that.act_receiver_firstname,
                act_receiver_lastname: that.act_receiver_lastname,
                act_receiver_position: that.act_receiver_position,
                act_giver_type: that.act_giver_type,
                act_giver_institution_name: that.act_giver_institution_name,
                act_giver_position: that.act_giver_position,
                act_giver_firstname: that.act_giver_firstname,
                act_giver_lastname: that.act_giver_lastname,
                act_giver_address: that.act_giver_address,
                act_giver_reg_nr: that.act_giver_reg_nr,
                act_due_date: that.act_due_date,
                act_author_position: that.act_author_position,
                act_author_firstname: that.act_author_firstname,
                act_author_lastname: that.act_author_lastname,
                annex_to_the_act: that.annex_to_the_act,

                agreement_number: that.agreement_number,
                agreement_date: that.agreement_date,
                agreement_receive_date: that.agreement_receive_date,
                agreement_extend_date: that.agreement_extend_date,
                purpose: that.purpose,
                notes: that.notes,

            }).then(response =>{
                if(response.data.status == 'ok')
                {
                    that.loading = false;
                    that.$toast.open(response.data.message);
                }
                else {
                    that.$toast.error(response.data.message);
                }
            });
        },
        populateActDataWithCurrentUser() {
            this.act_receiver_firstname = this.$props.current_user.firstname;
            this.act_receiver_lastname = this.$props.current_user.lastname;
            this.act_receiver_position = this.$props.current_user.position;
        },

        populateActAuthorWithCurrentUser(){
            this.act_author_firstname = this.$props.current_user.firstname;
            this.act_author_lastname = this.$props.current_user.lastname;
            this.act_author_position = this.$props.current_user.position;
        },
    }
}
</script>

<style lang="scss" scoped>
@use "sass:color";
@import '../../../sass/variables';
.itemActions{
    width:150px;
    display:flex;
    align-items: center;
    justify-content: center;
    .action{
        cursor:pointer;
        padding:15px;
        &.view{
            color:$blue;
        }
        &.delete{
            color:$red;
        }
    }
}
.actions{
    display:flex;
    justify-content: flex-end;
    margin-bottom:20px;
}
.content{
    position:relative;
    display:flex;
    .main{
        flex-basis:800px;
        flex-grow:1;
    }
    .sidebar{
        flex-basis:400px;
        flex-grow:0;
        flex-shrink:0;
        margin-left:30px;
    }
}
.section{
    box-shadow: 0 1px 10px rgba(0,0,0,.1);
    margin:15px 0;
    .subsection
    {
        width:100%;
        display:flex;
        align-items: center;
        padding-bottom:5px;
        padding-top:10px;
        border-bottom:solid 5px #eee;
        margin-bottom:15px;
        .title{
            font-size:18px;
            font-weight:bold;
        }
        .actions{
            display:flex;
            align-items: center;
            margin-left:auto;
            margin-bottom:0px;
        }
    }
    hr{
        width:100%;
        display:block;
    }
    .sectionTitle{
        cursor:pointer;
        font-size:16px;
        font-weight: 700;
        text-transform: uppercase;
        padding:15px 20px;
        background-color:$blue;
        color:#fff;
    }
    .sectionContent{
        width:100%;
        padding:10px 20px 20px 20px;
        img{
            width:100px;
            height:auto;
        }
    }
}
</style>
